export default {
  data() {
    return {
      audio: null,
    };
  },
  methods: {
    setAudio(audio) {
      if (!audio?.url) {
        return; // No audio to play if no audio URL is found
      }

      this.audio = new Audio(audio.url);
      this.audio.loop = audio.loop;
    },
    playAudio() {
      if (!this.audio) {
        return; // No audio to play
      }

      this.audio.play();
    },
    stopAudio() {
      if (!this.audio) {
        return; // No audio to stop
      }

      this.audio.pause();
      this.audio.currentTime = 0;
    },
  },
  mounted() {
    this.playAudio();
  },
  beforeUnmount() {
    this.stopAudio();
  },
};
